import "./styles.css";
import { createRoot } from "react-dom/client";
import { Auth0Provider } from "@auth0/auth0-react";
import App from "./app";
import { Providers } from "@/providers";
import { getAuth0Config } from "@/shared/auth-config";

const root = createRoot(document.getElementById("app")!);

// Get Auth0 configuration for current environment
const auth0Config = getAuth0Config();

root.render(
  <Auth0Provider {...auth0Config}>
    <Providers>
      <App />
    </Providers>
  </Auth0Provider>
);
